import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { CompaniesAppController } from '../controller/CompaniesAppController';

export class CompaniesAppWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CompaniesAppController,
    });
  }
}
